var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1 1.4C8.71339 1.4 8.4 1.0866 8.4 0.7C8.4 0.3134 8.71339 0 9.1 0H13.3C13.6866 0 14 0.3134 14 0.7V4.9C14 5.2866 13.6866 5.6 13.3 5.6C12.9134 5.6 12.6 5.2866 12.6 4.9V2.38995L6.09498 8.89497C5.82161 9.16832 5.37839 9.16832 5.10502 8.89497C4.83166 8.62162 4.83166 8.17838 5.10502 7.90503L11.6101 1.4H9.1ZM2.1 3.5C1.91435 3.5 1.7363 3.57375 1.60502 3.70502C1.47375 3.8363 1.4 4.01435 1.4 4.2V11.9C1.4 12.0856 1.47375 12.2637 1.60502 12.395C1.7363 12.5262 1.91435 12.6 2.1 12.6H9.8C9.98564 12.6 10.1637 12.5262 10.295 12.395C10.4262 12.2637 10.5 12.0856 10.5 11.9V7.7C10.5 7.31339 10.8134 7 11.2 7C11.5866 7 11.9 7.31339 11.9 7.7V11.9C11.9 12.457 11.6787 12.9911 11.2849 13.3849C10.8911 13.7787 10.357 14 9.8 14H2.1C1.54304 14 1.0089 13.7787 0.615076 13.3849C0.221249 12.9911 0 12.457 0 11.9V4.2C0 3.64304 0.221249 3.1089 0.615076 2.71508C1.0089 2.32125 1.54304 2.1 2.1 2.1H6.3C6.6866 2.1 7 2.4134 7 2.8C7 3.1866 6.6866 3.5 6.3 3.5H2.1Z",
    fill: "var(--primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.b524c10a3a80dd5fe42897851c7986e6.svg";
export { ForwardRef as ReactComponent };